import React from "react";
import {
  FaSearch,
  FaExclamation,
  FaTimes,
  FaLightbulb,
  FaBuilding,
  FaTachometerAlt,
  FaExclamationCircle,
  FaEnvelope,
  FaEnvelopeOpen,
  FaEnvelopeOpenText,
  FaEnvelopeSquare,
} from "react-icons/fa";
import LeftPanel_Home from "./LeftPanel_Home";

function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Main Layout */}
      <div className="flex flex-grow">
        {/*  Left Margin (hide on small) (10%) */}
        <div className="hidden lg:block lg:w-[20%]"></div>

        <LeftPanel_Home />

        {/* Main Content (60%) */}
        {/* <div className="w-[60%] flex flex-col px-4 py-6"> */}
         <div className="w-full lg:w-[60%] flex flex-col px-4 py-6">
         {/* Search Bar */}
<div className="flex justify-end">
  <div className="flex flex-wrap items-center mb-6 w-full sm:w-auto ">
    <button className="bg-[#7ABC32] text-white px-3 py-2 rounded-md sm:rounded-l-md sm:rounded-r-none">
      Search by Account
    </button>
    <div className="relative flex-grow sm:flex-grow-0 sm:w-80">
      <input
        type="text"
        placeholder="Account Number or NMI/Meter"
        className="w-full px-3 py-2 border rounded-md sm:rounded-r-md sm:rounded-l-none  focus:outline-none focus:ring-0 focus:ring-[#7ABC32] italic text-gray-800"
      />
      <FaSearch
        className="absolute right-2 top-3 text-blue-500 cursor-pointer "
        size={15}
        title="Search"
      />
    </div>
  </div>
</div>


          {/* BERT Title */}
          <div className="text-5xl p-4 font-bold text-[#002060]">BERT</div>

          {/* Content Box */}
          <div className="bg-gray-100 p-4 flex-grow">
            <h2 className="text-2xl mb-12 text-gray-700">
              Empowering Smarter Energy Decisions
            </h2>
            <p className="mb-4 text-base font-bold text-gray-700">
              Hello John,
            </p>
            <p className="mb-4 text-base text-gray-700">
  Welcome to BERT, your all-in-one{' '}
  <b>B</b>illing <b>E</b>nergy <b>R</b>eporting <b>T</b>ool portal! Access and analyse your energy reports to monitor, manage,
  and optimise your usage anytime. Easily view, download, or share
  reports, and gain insights to support informed energy decisions.
</p>

            <p className="text-base text-gray-700">
              If you have any queries, feel free to reach out to the Energy
              Intelligence Operations team.
            </p>

            {/* Comment Box */}
            <div className="relative border-2 border-[#002060] bg-white p-2 rounded-lg mt-6">
              <FaTimes
                size={18}
                className="absolute top-3 right-3 text-gray-300 cursor-pointer"
                title="Close"
              />

              <div className="flex items-center space-x- mt-1">
                {/* Exclamation Icon */}
                {/* <FaExclamation
                  size={40} // Increased size for better vertical alignment
                  className="text-[#FF0000]"
                  // style={{ fontSize: "40px" }}
                  title="Notice"
                /> */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 64 115"
  height="200px"
  fill="#FF0000"
  className="text-[#FF0000]"
>
  {/* Exclamation vertical line */}
  <rect x="29" y="20" width="6" height="65" fill="#FF0000" />

  {/* Exclamation dot */}
  <circle cx="32" cy="100" r="6" fill="#FF0000" />
</svg>


                {/* Date & Header aligned vertically */}
                <div>
                  <p className="text-gray-800 text-sm">15 April 2025</p>
                  <h3 className="text-red-800 text-base font-semibold">
                    CONTRACT EXPIRING. URGENT ACTION REQUIRED
                  </h3>
                  <p className="text-gray-800 text-base mt-4">
                  Watergardens is coming out of contract on 1 July. We need to secure new contract.  Please reach 
out to George to discuss your options urgently.
                  </p>
                </div>
              </div>
            </div>

            {/* QUICK LINKS */}
            <h5 className="text-l font-semibold mt-8 mb-4 text-gray-800">
              QUICK LINKS
            </h5>
            <div className="flex gap-16 ml-20">
              <a
                href="https://aemo.com.au/en/energysystems/electricity/national-electricitymarket-nem/data-nem/data-dashboardnem"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/aemo-logo.svg"
                  alt="AEMO"
                  className="w-32 h-auto"
                />
              </a>
              <a
                href="https://www.asxenergy.com.au/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/asx-logo-blue.svg"
                  alt="ASX"
                  className="w-32 h-auto"
                />
              </a>
             
              <div className="flex items-center space-x-2">
  {/* Image linking to energyintel.com.au */}
  <a href="https://www.energyintel.com.au/" target="_blank" rel="noopener noreferrer">
    <img src="/assets/images/EI.png" alt="ASX" className="h-12 w-auto" />
  </a>

  {/* Envelope icon linking to email */}
  <a href="mailto:ops@energyintel.com.au" title="Email us">
    <svg
      viewBox="0 0 64 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="white"
      stroke="black"
      strokeWidth="3"
      className="h-12 w-auto"
    >
      <rect x="1" y="8" width="62" height="32" fill="white" />
      <polyline points="1,8 32,28 63,8" stroke="black" strokeWidth="2" fill="none" />
    </svg>
  </a>
</div>

              
            </div>
          </div>
        </div>

        {/* Right Margin (10%) */}
        {/* <div className="w-[20%]"></div> */}
        {/* Right Margin (hide on small) */}
        <div className="hidden lg:block lg:w-[20%]"></div>
      </div>
    </div>
  );
}

export default Home;
